import { useState, useEffect } from 'react';
/*
    When recording a voice note -> we need these states to indicate the status of the voice note
    Needed especially when user for some reason leaves the page in the middle of voice note submission
*/
export var VoiceNoteStatus;
(function (VoiceNoteStatus) {
    VoiceNoteStatus["IDLE"] = "IDLE";
    VoiceNoteStatus["RECORDING"] = "RECORDING";
    VoiceNoteStatus["STOPPED"] = "STOPPED";
    VoiceNoteStatus["GETTING_PROFILE_SUGGESTIONS"] = "GETTING_PROFILE_SUGGESTIONS";
    VoiceNoteStatus["TRANSCRIBING"] = "TRANSCRIBING";
    VoiceNoteStatus["TRANSCRIPTION_RECEIVED_SUCCESS"] = "TRANSCRIPTION_RECEIVED_SUCCESS";
    VoiceNoteStatus["RECEIVED_PROFILE_SUGGESTIONS_SUCCESS"] = "RECEIVED_PROFILE_SUGGESTIONS_SUCCESS";
    VoiceNoteStatus["RECEIVED_PROFILE_SUGGESTIONS_ERROR"] = "RECEIVED_PROFILE_SUGGESTIONS_ERROR";
    VoiceNoteStatus["ASSIGNING"] = "ASSIGNING";
    VoiceNoteStatus["ASSIGNED_SUCCESS"] = "ASSIGNED_SUCCESS";
    VoiceNoteStatus["ASSIGNED_ERROR"] = "ASSIGNED_ERROR";
    VoiceNoteStatus["TRANSCRIPTION_TAKING_TOO_LONG"] = "TRANSCRIPTION_TAKING_TOO_LONG";
})(VoiceNoteStatus || (VoiceNoteStatus = {}));
export var defaultVoiceNoteState = {
    seconds: 0,
    voiceNoteStatus: 'IDLE',
    voiceNote: undefined,
    suggestedProfiles: [],
    chosenProfile: undefined
};
export var AUDIO_SECONDS_LIMIT = 10;
export var SUBMIT_TIMEOUT_SECONDS_LIMIT = 15;
/*
    Refined use state hook -> when we need to store the state in local storage
    TODO - use it in other components whenever we need to store something outside of component without using redux
*/
export function useGroupedPersistedState(organizationId, key) {
    if (key === void 0) { key = 'voiceNoteGroupedState'; }
    var _a = useState(function () {
        try {
            var stored = localStorage.getItem(key + '-' + organizationId);
            return stored ? JSON.parse(stored) : defaultVoiceNoteState;
        }
        catch (e) {
            console.error("Failed to load ".concat(key, " from localStorage"), e);
            return defaultVoiceNoteState;
        }
    }), state = _a[0], setState = _a[1];
    useEffect(function () {
        try {
            localStorage.setItem(key + '-' + organizationId, JSON.stringify(state));
        }
        catch (e) {
            console.error("Failed to save ".concat(key, " to localStorage"), e);
        }
    }, [key, state]);
    return [state, setState];
}
// Reformating the audio that has been recorded
export function blobToBase64(blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
